import actionTypes from '../actions/types';
import actionFactory from '../actions/actionsFactory/types';

const { RESET_TRADE_ORDERS_PAGINATION } = actionFactory;
export const INITIAL_STATE = {
  tradeOrders: [], // [...]
  tradeOrdersStart: -1,
  tradeOrdersEnd: -1,
  marginTradeOrders: [],
};

// shared
export const handleSetTradeOrdersPeriod = (state, { data }) => ({
  ...state,
  tradeOrdersPeriod: data,
});

// exchange
export const handleSetTradeOrders = (state, { data, pagination }) => ({
  ...state,
  tradeOrders: data ? [...data] : [],
  tradeOrdersPagination: pagination,
});

export const handleSetMarginTradeOrdersWithBefore = (state, { data, pagination }) => ({
  ...state,
  marginTradeOrders: [...state.marginTradeOrders, ...data],
  tradeOrdersPagination: pagination,
});

// margin
export const handleSetMarginTradeOrders = (state, { data, pagination }) => ({
  ...state,
  marginTradeOrders: data ? [...data] : [],
  tradeOrdersPagination: pagination,
});

export const handleSetTradeOrdersWithBefore = (state, { data, pagination }) => ({
  ...state,
  tradeOrders: [...state.tradeOrders, ...data],
  tradeOrdersPagination: pagination,
});

export const resetTradeOrdersPagination = (state) => ({
  ...state,
  tradeOrdersPagination: { ...state.tradeOrdersPagination, page: 0, pages: 1 },
});


export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_TRADE_ORDERS_DATA:
      return handleSetTradeOrders(state, action);
    case actionTypes.SET_TRADE_ORDERS_DATA_WITH_BEFORE:
      return handleSetTradeOrdersWithBefore(state, action);
    case actionTypes.SET_TRADE_ORDERS_PERIOD:
      return handleSetTradeOrdersPeriod(state, action);
    case actionTypes.SET_MARGIN_TRADE_ORDERS_DATA:
      return handleSetMarginTradeOrders(state, action);
    case actionTypes.SET_MARGIN_TRADE_ORDERS_DATA_WITH_BEFORE:
      return handleSetMarginTradeOrdersWithBefore(state, action);
    case RESET_TRADE_ORDERS_PAGINATION:
      return resetTradeOrdersPagination(state, action);
    default:
      return state;
  }
};
